"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation createFee($fee: FeeInput!) {
    createFee(fee: $fee) {
      _id
      name
      orgId
      eventId
      seasonId
      type
      value
      appliedTo
      appliedBy
      minAppliedToPrice
      maxAppliedToPrice
      filters
      createdBy
      createdAt
      updatedBy
      updatedAt
      disabled
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=createFee.mutation.js.map